// Peticiones que abortamos NOSOTROS, no fallos. Cuando el controlador pulsa
// "trabajar offline", el interceptor de axios aborta todo lo que salga (y
// setUserOfflineMode cancela además lo que estuviera en vuelo). Axios lo
// entrega como CanceledError/ERR_CANCELED.
//
// Dos consumidores, por motivos distintos:
//   - La telemetria: un aborto no es un error y no debe pintarse en rojo en el
//     visor (una tarde offline dejo 23, tapando los 2 timeouts reales).
//   - La cola offline: un aborto no debe consumir reintento ni backoff. Sin
//     esto, pulsar "Trabajar offline" a mitad de una subida castigaba a todos
//     los items en vuelo (visto en campo: 15 de golpe).
//
// Se detecta por el codigo del error, NO por isUserOfflineMode(): entre el
// abort y el catch el usuario puede haber vuelto a online (pasa en cada sync
// tras recuperar cobertura) y entonces la comprobacion por estado dejaria
// escapar justo las cancelaciones del cambio de modo.
//
// AbortError cubre lo mismo para los fetch nativos (weather, geocoding...),
// que cancelan por timeout propio.
export function esCancelacionPropia(error: unknown): boolean {
  const err = error as { name?: string; code?: string } | null | undefined;
  return err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError' || err?.name === 'AbortError';
}
